/* eslint-disable max-len */
import React from 'react';
function Scorm() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 3H21C22.1 3 23 3.89 23 5L22.99 17C22.99 18.1 22.1 19 21 19H16V21H8V19H3C1.89 19 1 18.1 1 17V5C1 3.89 1.89 3 3 3ZM3 17H21V5H3V17Z" })));
}
export default Scorm;
